import {jsx as $bWnsf$jsx, jsxs as $bWnsf$jsxs} from "react/jsx-runtime";
import {useMemo as $bWnsf$useMemo, useReducer as $bWnsf$useReducer, Fragment as $bWnsf$Fragment, createContext as $bWnsf$createContext, useEffect as $bWnsf$useEffect, useCallback as $bWnsf$useCallback, useContext as $bWnsf$useContext, useRef as $bWnsf$useRef, useLayoutEffect as $bWnsf$useLayoutEffect} from "react";
import {useMsal as $bWnsf$useMsal} from "@azure/msal-react";
import {Helmet as $bWnsf$Helmet} from "react-helmet";
import {Button as $bWnsf$Button, Avatar as $bWnsf$Avatar, Subtitle2 as $bWnsf$Subtitle2, Body1 as $bWnsf$Body1, Divider as $bWnsf$Divider, Link as $bWnsf$Link, Tooltip as $bWnsf$Tooltip, makeStyles as $bWnsf$makeStyles, shorthands as $bWnsf$shorthands, tokens as $bWnsf$tokens, Card as $bWnsf$Card, CardHeader as $bWnsf$CardHeader, Menu as $bWnsf$Menu, MenuTrigger as $bWnsf$MenuTrigger, MenuPopover as $bWnsf$MenuPopover, MenuList as $bWnsf$MenuList, MenuItem as $bWnsf$MenuItem, Body1Strong as $bWnsf$Body1Strong, Caption2 as $bWnsf$Caption2} from "@fluentui/react-components";
import {Dismiss24Regular as $bWnsf$Dismiss24Regular, Info16Regular as $bWnsf$Info16Regular, bundleIcon as $bWnsf$bundleIcon, Home24Filled as $bWnsf$Home24Filled, Home24Regular as $bWnsf$Home24Regular, Open24Filled as $bWnsf$Open24Filled, Open24Regular as $bWnsf$Open24Regular, MoreHorizontal24Filled as $bWnsf$MoreHorizontal24Filled} from "@fluentui/react-icons";
import {DrawerOverlay as $bWnsf$DrawerOverlay, DrawerHeader as $bWnsf$DrawerHeader, DrawerHeaderTitle as $bWnsf$DrawerHeaderTitle, DrawerBody as $bWnsf$DrawerBody} from "@fluentui/react-components/unstable";
import $bWnsf$axios from "axios";

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire3861"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire3861"] = parcelRequire;
}
parcelRequire.register("VYqWw", function(module, exports) {
module.exports = import("./ar-sa.43fb0bb1.js").then(()=>parcelRequire("lEkGj"));

});

parcelRequire.register("k9neF", function(module, exports) {
module.exports = import("./bg-bg.a87dd043.js").then(()=>parcelRequire("7epZ6"));

});

parcelRequire.register("8ZQUb", function(module, exports) {
module.exports = import("./cs-cz.11c953b3.js").then(()=>parcelRequire("6YJs9"));

});

parcelRequire.register("fq3V0", function(module, exports) {
module.exports = import("./da-dk.27b5ae07.js").then(()=>parcelRequire("1cPxJ"));

});

parcelRequire.register("a2jx9", function(module, exports) {
module.exports = import("./de-de.952c75c1.js").then(()=>parcelRequire("eN9GL"));

});

parcelRequire.register("4fDl7", function(module, exports) {
module.exports = import("./el-gr.de91b125.js").then(()=>parcelRequire("4Re2G"));

});

parcelRequire.register("gwJbz", function(module, exports) {
module.exports = import("./es-es.24cc3e2c.js").then(()=>parcelRequire("91yFA"));

});

parcelRequire.register("5RySV", function(module, exports) {
module.exports = import("./et-ee.70fc426b.js").then(()=>parcelRequire("55Zvx"));

});

parcelRequire.register("lqUdO", function(module, exports) {
module.exports = import("./fi-fi.a9fdebaa.js").then(()=>parcelRequire("a3vEf"));

});

parcelRequire.register("joUAR", function(module, exports) {
module.exports = import("./fr-fr.24d7d513.js").then(()=>parcelRequire("keFiy"));

});

parcelRequire.register("bR1qF", function(module, exports) {
module.exports = import("./he-il.2f1e95e9.js").then(()=>parcelRequire("glBzR"));

});

parcelRequire.register("97L73", function(module, exports) {
module.exports = import("./hi-in.b94d4b32.js").then(()=>parcelRequire("3ZoEa"));

});

parcelRequire.register("chz5L", function(module, exports) {
module.exports = import("./hr-hr.5660d2c0.js").then(()=>parcelRequire("iwBvT"));

});

parcelRequire.register("jeK0Z", function(module, exports) {
module.exports = import("./hu-hu.eeea9151.js").then(()=>parcelRequire("8OYC9"));

});

parcelRequire.register("5Rv06", function(module, exports) {
module.exports = import("./id-id.b279933d.js").then(()=>parcelRequire("dMUcg"));

});

parcelRequire.register("fXEkY", function(module, exports) {
module.exports = import("./it-it.d7934ca7.js").then(()=>parcelRequire("iBTtz"));

});

parcelRequire.register("ey4NM", function(module, exports) {
module.exports = import("./ja-jp.b8287e1f.js").then(()=>parcelRequire("4iGPb"));

});

parcelRequire.register("8zmZO", function(module, exports) {
module.exports = import("./kk-kz.4fa53cbf.js").then(()=>parcelRequire("dcfoV"));

});

parcelRequire.register("hKjIa", function(module, exports) {
module.exports = import("./ko-kr.bf048938.js").then(()=>parcelRequire("clZO4"));

});

parcelRequire.register("bc9D9", function(module, exports) {
module.exports = import("./lt-lt.ff0835bc.js").then(()=>parcelRequire("dch8k"));

});

parcelRequire.register("5k5pm", function(module, exports) {
module.exports = import("./lv-lv.ceb8bb07.js").then(()=>parcelRequire("fcApL"));

});

parcelRequire.register("hjOKP", function(module, exports) {
module.exports = import("./ms-my.057b6a7a.js").then(()=>parcelRequire("gH7KA"));

});

parcelRequire.register("9qn2y", function(module, exports) {
module.exports = import("./nb-no.d083e239.js").then(()=>parcelRequire("2ZhvY"));

});

parcelRequire.register("n2T3T", function(module, exports) {
module.exports = import("./nl-nl.ea49a583.js").then(()=>parcelRequire("dhijY"));

});

parcelRequire.register("EolEX", function(module, exports) {
module.exports = import("./pl-pl.fc1a9c1b.js").then(()=>parcelRequire("l1Ayq"));

});

parcelRequire.register("2Hyxz", function(module, exports) {
module.exports = import("./pt-pt.d1d7f7d0.js").then(()=>parcelRequire("gNWO8"));

});

parcelRequire.register("gGjOf", function(module, exports) {
module.exports = import("./ro-ro.530c0ead.js").then(()=>parcelRequire("eq5FD"));

});

parcelRequire.register("8S2V6", function(module, exports) {
module.exports = import("./ru-ru.952c3bac.js").then(()=>parcelRequire("2xNcu"));

});

parcelRequire.register("gHqGZ", function(module, exports) {
module.exports = import("./sk-sk.34109e8a.js").then(()=>parcelRequire("j1fKC"));

});

parcelRequire.register("iiFmz", function(module, exports) {
module.exports = import("./sl-sl.7c2d87a5.js").then(()=>parcelRequire("1IWmM"));

});

parcelRequire.register("7YsVm", function(module, exports) {
module.exports = import("./sr-latn-rs.fa70c5b0.js").then(()=>parcelRequire("ksQvf"));

});

parcelRequire.register("ev6B0", function(module, exports) {
module.exports = import("./sv-se.d762841a.js").then(()=>parcelRequire("bo5qo"));

});

parcelRequire.register("7QZWZ", function(module, exports) {
module.exports = import("./th-th.85ee818c.js").then(()=>parcelRequire("kAM4M"));

});

parcelRequire.register("1lTVB", function(module, exports) {
module.exports = import("./tr-tr.baeb5ea4.js").then(()=>parcelRequire("if68x"));

});

parcelRequire.register("ccqzd", function(module, exports) {
module.exports = import("./uk-ua.8e4cdad0.js").then(()=>parcelRequire("bX6sq"));

});

parcelRequire.register("iINe7", function(module, exports) {
module.exports = import("./vi-vn.d3edfb59.js").then(()=>parcelRequire("et1ai"));

});

parcelRequire.register("kRSKR", function(module, exports) {
module.exports = import("./zh-cn.9bc7e9d6.js").then(()=>parcelRequire("kJG5f"));

});

parcelRequire.register("jQTng", function(module, exports) {
module.exports = import("./zh-tw.099c9522.js").then(()=>parcelRequire("7LrVG"));

});

var $90b60284c280181b$exports = {};

$parcel$export($90b60284c280181b$exports, "GameDevAuthProvider", () => $90b60284c280181b$export$97a7af6687d86f01);



var $9462891c6413158f$exports = {};
$9462891c6413158f$exports = JSON.parse('{"FriendlyName":"English US","SwitchDirectory":"Switch directory","LinkText":"Learn more about AzureAD","Current":"Current","SwitchTo":"Switch to","SetAsDefault":"Set as your default tenant","ThisIsDefault":"This is your default tenant","ManageInAzure":"Manage in Azure","ViewAccessPrivileges":"View access privileges","CloseButtonLabel":"Close","PinButtonLabel":"Pin","UnpinButtonLabel":"Unpin","OptionsButtonLabel":"Options","DefaultStarLabel":"Default","LoadingTenants":"Loading...","SwitchingTenants":"Switch to {0}...","AccountsInDirectory":"Accounts in this directory:","CurrentTenantAccount":"Current tenant account"}');


const $b076962551ace194$export$21c51bc433c16634 = (0, (/*@__PURE__*/$parcel$interopDefault($9462891c6413158f$exports)));


function $be3d5279182e64a2$export$a3665b844fbc095d(state, action) {
    if (state.lang === action.payload) return state;
    return {
        ...state,
        lang: action.payload
    };
}
function $be3d5279182e64a2$export$2e49b867b7a0847c(state, action) {
    if (state.theme === action.payload) return state;
    return {
        ...state,
        theme: action.payload
    };
}
function $be3d5279182e64a2$export$2fec06214831496a(state, action) {
    if (state.dirPickerState === action.payload) return state;
    if (action.payload !== "pinned") $parcel$global?.localStorage?.removeItem("GDAS_DIR_PICKER_PINNED");
    else $parcel$global?.localStorage?.setItem("GDAS_DIR_PICKER_PINNED", "true");
    return {
        ...state,
        dirPickerState: action.payload
    };
}
function $be3d5279182e64a2$export$f114d1bb5e8cd6b2(state, action) {
    if (state.account === action.payload) return state;
    return {
        ...state,
        account: action.payload,
        tenantId: null,
        sellerId: null
    };
}
function $be3d5279182e64a2$export$5aae57340dd12cd8(state, action) {
    if (state.defaultTenantId === action.payload) return state;
    $parcel$global?.localStorage?.setItem("GDAS_DEFAULT_TENANT", action.payload);
    return {
        ...state,
        defaultTenantId: action.payload
    };
}
function $be3d5279182e64a2$export$865f90b30eb6c368(state, action) {
    if (state.defaultSellerId === action.payload) return state;
    $parcel$global?.localStorage?.setItem("GDAS_DEFAULT_SELLER", action.payload);
    return {
        ...state,
        defaultSellerId: action.payload
    };
}
function $be3d5279182e64a2$export$caac5cbbbde13513(state, action) {
    // If the tenant didn't change or the tenant is not available don't make any changes
    if (state.tenantId === action.payload || !state.tenants?.some((t)=>t.tenantId === action.payload)) return state;
    return {
        ...state,
        tenantId: action.payload
    };
}
function $be3d5279182e64a2$export$65452e782cdd0873(state, action) {
    // If the sellert didn't change or the seller is not available don't make any changes
    if (state.sellerId === action.payload || !state.sellers?.some((t)=>t.sellerId === action.payload)) return state;
    return {
        ...state,
        sellerId: action.payload
    };
}
function $be3d5279182e64a2$export$bd4296c107933e7f(state, action) {
    if (state.tenants === action.payload) return state;
    const newState = {
        ...state,
        tenants: action.payload
    };
    // When the tenants are defined if the selected tenant is not available reset it  
    if (!newState.tenantId || !newState.tenants?.some((t)=>t.tenantId === state.tenantId)) {
        // If the default tenant id is available set it
        if (state.defaultTenantId && newState.tenants?.some((t)=>t.tenantId === state.defaultTenantId)) newState.tenantId = state.defaultTenantId;
        else if (state.account?.tenantId && newState.tenants?.some((t)=>t.tenantId === state.account.tenantId)) newState.tenantId = state.account.tenantId;
        else newState.tenantId = newState.tenants?.length > 0 ? newState.tenants[0].tenantId : null;
    }
    return newState;
}
function $be3d5279182e64a2$export$5aecdcbfa793bff8(state, action) {
    if (state.sellers === action.payload) return state;
    const newState = {
        ...state,
        sellers: action.payload
    };
    // When the sellers are defined if the selected seller is not available reset it
    if (!newState.sellerId || !newState.sellers?.some((t)=>t.sellerId === newState.sellerId)) {
        // If the default seller id is available set it
        if (state.defaultSellerId && newState.sellers?.some((t)=>t.sellerId === state.defaultSellerId)) newState.defaultSellerId = state.defaultSellerId;
        else newState.sellerId = newState.sellers?.length > 0 ? newState.sellers?.[0].sellerId : null;
    }
    return newState;
}
function $be3d5279182e64a2$export$6f7aecedd0de460e(state, action) {
    if (state.claims === action.payload) return state;
    return {
        ...state,
        claims: action.payload
    };
}


const $aaacbdc4bf3bda8c$export$a0fd8390cfe8ae69 = (0, $bWnsf$createContext)(null);
const $aaacbdc4bf3bda8c$export$9f27bc3417b4524d = $aaacbdc4bf3bda8c$export$a0fd8390cfe8ae69.Provider;
const $aaacbdc4bf3bda8c$export$49d5fc8cba920a0 = {
    clientId: "",
    partnerId: "",
    instance: "https://login.microsoftonline.com",
    theme: "light",
    lang: "en-us",
    dirPickerState: String($parcel$global?.localStorage?.getItem("GDAS_DIR_PICKER_PINNED"))?.toLowerCase() === "true" ? "pinned" : "closed",
    account: null,
    defaultTenantId: $parcel$global?.localStorage?.getItem("GDAS_DEFAULT_TENANT"),
    defaultSellerId: $parcel$global?.localStorage?.getItem("GDAS_DEFAULT_SELLER"),
    sellerId: null,
    tenantId: null,
    sellers: null,
    tenants: null,
    claims: null,
    strings: (0, $b076962551ace194$export$21c51bc433c16634)
};
function $aaacbdc4bf3bda8c$export$2803ff8111172487(state, action) {
    switch(action.type){
        case "set_lang":
            return (0, $be3d5279182e64a2$export$a3665b844fbc095d)(state, action);
        case "set_theme":
            return (0, $be3d5279182e64a2$export$2e49b867b7a0847c)(state, action);
        case "set_dir_picker_state":
            return (0, $be3d5279182e64a2$export$2fec06214831496a)(state, action);
        case "set_account":
            return (0, $be3d5279182e64a2$export$f114d1bb5e8cd6b2)(state, action);
        case "set_default_tenant_id":
            return (0, $be3d5279182e64a2$export$5aae57340dd12cd8)(state, action);
        case "set_default_seller_id":
            return (0, $be3d5279182e64a2$export$865f90b30eb6c368)(state, action);
        case "set_tenant_id":
            return (0, $be3d5279182e64a2$export$caac5cbbbde13513)(state, action);
        case "set_seller_id":
            return (0, $be3d5279182e64a2$export$65452e782cdd0873)(state, action);
        case "set_tenants":
            return (0, $be3d5279182e64a2$export$bd4296c107933e7f)(state, action);
        case "set_sellers":
            return (0, $be3d5279182e64a2$export$5aecdcbfa793bff8)(state, action);
        case "set_claims":
            return (0, $be3d5279182e64a2$export$6f7aecedd0de460e)(state, action);
        default:
            return state;
    }
}





var $21975582a087385b$exports = {};

$parcel$export($21975582a087385b$exports, "useGameDevAuthContext", () => $21975582a087385b$export$8a1842fae71241ae);


function $21975582a087385b$export$8a1842fae71241ae() {
    return (0, $bWnsf$useContext)((0, $aaacbdc4bf3bda8c$export$a0fd8390cfe8ae69));
}


function $a123e35769e182e0$export$938b22d9142905e3() {
    const [state, dispatch] = (0, $21975582a087385b$export$8a1842fae71241ae)();
    const setter = (0, $bWnsf$useCallback)((strings)=>dispatch({
            type: "set_strings",
            payload: strings
        }), [
        dispatch
    ]);
    return (0, $bWnsf$useMemo)(()=>[
            state.strings,
            setter
        ], [
        setter,
        state.strings
    ]);
}


var $7a51392e39a432a5$exports = {};

$parcel$export($7a51392e39a432a5$exports, "useGameDevAuthLang", () => $7a51392e39a432a5$export$2694ca027c248780);


function $7a51392e39a432a5$export$2694ca027c248780() {
    const [state, dispatch] = (0, $21975582a087385b$export$8a1842fae71241ae)();
    const setter = (0, $bWnsf$useCallback)((lang)=>dispatch({
            type: "set_lang",
            payload: lang
        }), [
        dispatch
    ]);
    return (0, $bWnsf$useMemo)(()=>[
            state.lang,
            setter
        ], [
        setter,
        state.lang
    ]);
}









































async function $0c6886105ae77fef$export$51b9bdf651c1e916(lang) {
    try {
        // each language must be imported separately to avoid bundling all languages
        // see https://parceljs.org/features/scope-hoisting/#dynamic-imports
        switch(lang){
            case "ar-sa":
                {
                    const { default: strs } = await (parcelRequire("VYqWw"));
                    return strs;
                }
            case "bg-bg":
                {
                    const { default: strs } = await (parcelRequire("k9neF"));
                    return strs;
                }
            case "cs-cz":
                {
                    const { default: strs } = await (parcelRequire("8ZQUb"));
                    return strs;
                }
            case "da-dk":
                {
                    const { default: strs } = await (parcelRequire("fq3V0"));
                    return strs;
                }
            case "de-de":
                {
                    const { default: strs } = await (parcelRequire("a2jx9"));
                    return strs;
                }
            case "el-gr":
                {
                    const { default: strs } = await (parcelRequire("4fDl7"));
                    return strs;
                }
            case "es-es":
                {
                    const { default: strs } = await (parcelRequire("gwJbz"));
                    return strs;
                }
            case "et-ee":
                {
                    const { default: strs } = await (parcelRequire("5RySV"));
                    return strs;
                }
            case "fi-fi":
                {
                    const { default: strs } = await (parcelRequire("lqUdO"));
                    return strs;
                }
            case "fr-fr":
                {
                    const { default: strs } = await (parcelRequire("joUAR"));
                    return strs;
                }
            case "he-il":
                {
                    const { default: strs } = await (parcelRequire("bR1qF"));
                    return strs;
                }
            case "hi-in":
                {
                    const { default: strs } = await (parcelRequire("97L73"));
                    return strs;
                }
            case "hr-hr":
                {
                    const { default: strs } = await (parcelRequire("chz5L"));
                    return strs;
                }
            case "hu-hu":
                {
                    const { default: strs } = await (parcelRequire("jeK0Z"));
                    return strs;
                }
            case "id-id":
                {
                    const { default: strs } = await (parcelRequire("5Rv06"));
                    return strs;
                }
            case "it-it":
                {
                    const { default: strs } = await (parcelRequire("fXEkY"));
                    return strs;
                }
            case "ja-jp":
                {
                    const { default: strs } = await (parcelRequire("ey4NM"));
                    return strs;
                }
            case "kk-kz":
                {
                    const { default: strs } = await (parcelRequire("8zmZO"));
                    return strs;
                }
            case "ko-kr":
                {
                    const { default: strs } = await (parcelRequire("hKjIa"));
                    return strs;
                }
            case "lt-lt":
                {
                    const { default: strs } = await (parcelRequire("bc9D9"));
                    return strs;
                }
            case "lv-lv":
                {
                    const { default: strs } = await (parcelRequire("5k5pm"));
                    return strs;
                }
            case "ms-my":
                {
                    const { default: strs } = await (parcelRequire("hjOKP"));
                    return strs;
                }
            case "nb-no":
                {
                    const { default: strs } = await (parcelRequire("9qn2y"));
                    return strs;
                }
            case "nl-nl":
                {
                    const { default: strs } = await (parcelRequire("n2T3T"));
                    return strs;
                }
            case "pl-pl":
                {
                    const { default: strs } = await (parcelRequire("EolEX"));
                    return strs;
                }
            case "pt-pt":
                {
                    const { default: strs } = await (parcelRequire("2Hyxz"));
                    return strs;
                }
            case "ro-ro":
                {
                    const { default: strs } = await (parcelRequire("gGjOf"));
                    return strs;
                }
            case "ru-ru":
                {
                    const { default: strs } = await (parcelRequire("8S2V6"));
                    return strs;
                }
            case "sk-sk":
                {
                    const { default: strs } = await (parcelRequire("gHqGZ"));
                    return strs;
                }
            case "sl-sl":
                {
                    const { default: strs } = await (parcelRequire("iiFmz"));
                    return strs;
                }
            case "sr-latn-rs":
                {
                    const { default: strs } = await (parcelRequire("7YsVm"));
                    return strs;
                }
            case "sv-se":
                {
                    const { default: strs } = await (parcelRequire("ev6B0"));
                    return strs;
                }
            case "th-th":
                {
                    const { default: strs } = await (parcelRequire("7QZWZ"));
                    return strs;
                }
            case "tr-tr":
                {
                    const { default: strs } = await (parcelRequire("1lTVB"));
                    return strs;
                }
            case "uk-ua":
                {
                    const { default: strs } = await (parcelRequire("ccqzd"));
                    return strs;
                }
            case "vi-vn":
                {
                    const { default: strs } = await (parcelRequire("iINe7"));
                    return strs;
                }
            case "zh-cn":
                {
                    const { default: strs } = await (parcelRequire("kRSKR"));
                    return strs;
                }
            case "zh-tw":
                {
                    const { default: strs } = await (parcelRequire("jQTng"));
                    return strs;
                }
            default:
                return 0, $b076962551ace194$export$21c51bc433c16634;
        }
    } catch (err) {
        console.error(err);
        console.warn("Defaulting to english language...");
        return 0, $b076962551ace194$export$21c51bc433c16634;
    }
}


function $b9f3ce3fba837e73$export$e60395c9a9ae0822() {
    const [lang] = (0, $7a51392e39a432a5$export$2694ca027c248780)();
    const [, setStrings] = (0, $a123e35769e182e0$export$938b22d9142905e3)();
    // Everytime the language is changed the strings are loaded
    (0, $bWnsf$useEffect)(()=>{
        (0, $0c6886105ae77fef$export$51b9bdf651c1e916)(lang).then(setStrings);
    }, [
        lang
    ]);
    return /*#__PURE__*/ (0, $bWnsf$jsx)((0, $bWnsf$Fragment), {});
}


function $90b60284c280181b$export$97a7af6687d86f01({ config: config, children: children, useAutoLangHandler: useAutoLangHandler = true }) {
    const initialState = (0, $bWnsf$useMemo)(()=>({
            ...(0, $aaacbdc4bf3bda8c$export$49d5fc8cba920a0),
            ...config
        }), []); // calculate only once
    const [state, dispatch] = (0, $bWnsf$useReducer)((0, $aaacbdc4bf3bda8c$export$2803ff8111172487), initialState);
    const context = (0, $bWnsf$useMemo)(()=>[
            state,
            dispatch
        ], [
        state,
        dispatch
    ]);
    return /*#__PURE__*/ (0, $bWnsf$jsx)((0, $bWnsf$Fragment), {
        children: /*#__PURE__*/ (0, $bWnsf$jsxs)((0, $aaacbdc4bf3bda8c$export$9f27bc3417b4524d), {
            value: context,
            children: [
                useAutoLangHandler && /*#__PURE__*/ (0, $bWnsf$jsx)((0, $b9f3ce3fba837e73$export$e60395c9a9ae0822), {}),
                children
            ]
        })
    });
}


var $74675ca70fa08556$exports = {};

$parcel$export($74675ca70fa08556$exports, "GameDevAuth", () => $74675ca70fa08556$export$deca11256f311257);


var $c0016381562d3c19$exports = {};

$parcel$export($c0016381562d3c19$exports, "GameDevAuthMeControl", () => $c0016381562d3c19$export$36d4625ab12df346);



let $3eaeb2bcdefcc96e$var$meControlLoaded = false;
function $3eaeb2bcdefcc96e$export$d912396f61553048({ account: account, clientId: clientId, signIn: signIn, switchTo: switchTo, signOut: signOut, instance: instance, replyUrl: replyUrl, container: container, theme: theme, commands: commands }) {
    const MeControl = $parcel$global.MeControl;
    if (!instance) instance = "https://login.microsoftonline.com";
    if (!theme) theme = "light";
    if (!commands) commands = [];
    const meControlContainer = container ?? document.getElementById("me-control-container");
    meControlContainer.className = "";
    meControlContainer.innerHTML = "";
    const meControlOptions = {
        apiGeneration: "GEN2",
        containerId: meControlContainer.id,
        currentAccount: {
            type: "aad",
            authenticatedState: !account ? "notSignedIn" : "signedIn",
            memberName: account?.username || "",
            displayName: account?.name || "",
            pictureUrl: account?.picture
        },
        authProviderConfig: {
            type: "msalJsAadOnly",
            signIn: signIn,
            signInTo: signIn,
            switchTo: switchTo,
            switch: switchTo,
            signOutFromApp: signOut,
            aad: {
                signOutUrl: `${instance}/uxlogout?appid=${clientId}&shouldForgetUser=false${!replyUrl ? "" : `&wreply=${replyUrl}`}`,
                signOutAndForgetUrl: `${instance}/uxlogout?appid=${clientId}&shouldForgetUser=true${!replyUrl ? "" : `&wreply=${replyUrl}`}`,
                forgetUrl: `${instance}/forgetuser`,
                rememberedAccountsUrl: `${instance}/savedusers?appid=${clientId}${!replyUrl ? "" : `&wreply=${replyUrl}`}`
            }
        },
        appContextConfig: {
            commands: commands?.map((c, i)=>({
                    type: "link",
                    id: `me-control-command-${i}`,
                    text: c.text,
                    ariaLabel: c.text,
                    openInNewTab: false,
                    onClick: c.onClick
                }))
        },
        primaryUXConfig: {
            theme: {
                type: theme
            },
            headerTheme: {
                type: theme
            }
        }
    };
    $3eaeb2bcdefcc96e$var$meControlLoaded = MeControl.Loader.load(meControlOptions);
    $parcel$global.onMeControlReadyToLoad = null;
}
function $3eaeb2bcdefcc96e$export$5567a1dcc5b2d136({ account: account, theme: theme }) {
    if (!$3eaeb2bcdefcc96e$var$meControlLoaded) return;
    if (!theme) theme = "light";
    const MeControl = $parcel$global.MeControl;
    MeControl.API.setActiveAccount({
        type: "aad",
        authenticatedState: !account ? "notSignedIn" : "signedIn",
        memberName: account?.username || "",
        displayName: account?.name || "",
        pictureUrl: account?.picture || ""
    });
    MeControl.API.setHeaderTheme({
        type: theme
    });
    MeControl.API.setTheme({
        type: theme
    });
}



var $73b8a0d69df8c02d$exports = {};

$parcel$export($73b8a0d69df8c02d$exports, "useGameDevAuthAccount", () => $73b8a0d69df8c02d$export$8b78e3b2832dcdba);


function $73b8a0d69df8c02d$export$8b78e3b2832dcdba() {
    const [state, dispatch] = (0, $21975582a087385b$export$8a1842fae71241ae)();
    const setter = (0, $bWnsf$useCallback)((account)=>dispatch({
            type: "set_account",
            payload: account
        }), [
        dispatch
    ]);
    return (0, $bWnsf$useMemo)(()=>[
            state.account,
            setter
        ], [
        setter,
        state.account
    ]);
}


var $3020c252d16c3fff$exports = {};

$parcel$export($3020c252d16c3fff$exports, "useGameDevAuthTheme", () => $3020c252d16c3fff$export$107c920f942946ca);


function $3020c252d16c3fff$export$107c920f942946ca() {
    const [state, dispatch] = (0, $21975582a087385b$export$8a1842fae71241ae)();
    const setter = (0, $bWnsf$useCallback)((theme)=>dispatch({
            type: "set_theme",
            payload: theme
        }), [
        dispatch
    ]);
    return (0, $bWnsf$useMemo)(()=>[
            state.theme,
            setter
        ], [
        setter,
        state.theme
    ]);
}


var $f69ccf510b0a32a4$exports = {};

$parcel$export($f69ccf510b0a32a4$exports, "useGameDevAuthMeta", () => $f69ccf510b0a32a4$export$dd40e6363faf0354);


function $f69ccf510b0a32a4$export$dd40e6363faf0354() {
    const [state] = (0, $21975582a087385b$export$8a1842fae71241ae)();
    return (0, $bWnsf$useMemo)(()=>({
            clientId: state.clientId,
            partnerId: state.partnerId,
            instance: state.instance
        }), [
        state.clientId,
        state.partnerId,
        state.instance,
        state
    ]);
}


var $1b99332a36d0bc3c$exports = {};

$parcel$export($1b99332a36d0bc3c$exports, "useGameDevAuthDirPicker", () => $1b99332a36d0bc3c$export$8029427447337e06);


function $1b99332a36d0bc3c$export$8029427447337e06() {
    const [state, dispatch] = (0, $21975582a087385b$export$8a1842fae71241ae)();
    const setter = (0, $bWnsf$useCallback)((newDirPickerState)=>dispatch({
            type: "set_dir_picker_state",
            payload: newDirPickerState
        }), [
        dispatch
    ]);
    return (0, $bWnsf$useMemo)(()=>[
            state.dirPickerState,
            setter
        ], [
        setter,
        state.dirPickerState
    ]);
}



function $c0016381562d3c19$export$36d4625ab12df346({ onSignIn: signIn, onSwitchTo: switchTo, onSignOut: signOut, commands: commands, meControlScriptUrl: meControlScriptUrl }) {
    const { clientId: clientId, partnerId: partnerId, instance: instance } = (0, $f69ccf510b0a32a4$export$dd40e6363faf0354)();
    const [language] = (0, $7a51392e39a432a5$export$2694ca027c248780)();
    const [account] = (0, $73b8a0d69df8c02d$export$8b78e3b2832dcdba)();
    const [theme] = (0, $3020c252d16c3fff$export$107c920f942946ca)();
    const [strings] = (0, $a123e35769e182e0$export$938b22d9142905e3)();
    const [, setDirPickerState] = (0, $1b99332a36d0bc3c$export$8029427447337e06)();
    const useDefaultCommands = !commands || commands.length === 0;
    const defaultCommands = (0, $bWnsf$useMemo)(()=>[
            {
                text: strings.SwitchDirectory,
                onClick: ()=>setDirPickerState("opened")
            }
        ], [
        strings.SwitchDirectory,
        setDirPickerState
    ]);
    const meControlScript = (0, $bWnsf$useMemo)(()=>meControlScriptUrl || `https://amcdn.msftauth.net/meversion?partner=${partnerId}&market=${language}`, [
        meControlScriptUrl,
        partnerId,
        language
    ]);
    const meControlContainer = (0, $bWnsf$useRef)(null);
    (0, $bWnsf$useEffect)(()=>{
        if (!meControlContainer.current) return;
        const options = {
            account: account,
            clientId: clientId,
            commands: useDefaultCommands ? defaultCommands : commands,
            instance: instance,
            theme: theme,
            container: meControlContainer.current,
            signIn: signIn,
            switchTo: switchTo,
            signOut: signOut
        };
        if ($parcel$global.MeControl) (0, $3eaeb2bcdefcc96e$export$d912396f61553048)(options);
        else $parcel$global.onMeControlReadyToLoad = ()=>(0, $3eaeb2bcdefcc96e$export$d912396f61553048)(options);
    }, [
        meControlContainer.current
    ]);
    (0, $bWnsf$useLayoutEffect)(()=>{
        (0, $3eaeb2bcdefcc96e$export$5567a1dcc5b2d136)({
            account: account,
            theme: theme
        });
    }, [
        account,
        commands,
        theme
    ]);
    return /*#__PURE__*/ (0, $bWnsf$jsxs)((0, $bWnsf$Fragment), {
        children: [
            !$parcel$global.MeControl && /*#__PURE__*/ (0, $bWnsf$jsx)((0, $bWnsf$Helmet), {
                children: /*#__PURE__*/ (0, $bWnsf$jsx)("script", {
                    src: meControlScript,
                    async: true
                })
            }),
            /*#__PURE__*/ (0, $bWnsf$jsx)("div", {
                ref: meControlContainer,
                id: "me-control-container"
            })
        ]
    });
}


var $b5d306f4b35768c6$exports = {};

$parcel$export($b5d306f4b35768c6$exports, "GameDevAuthDirectoryPicker", () => $b5d306f4b35768c6$export$105b0d753a45dc96);





const $67af8818136e32f9$export$f6740272b5923b9c = "Segoe Sans, Helvetica Neue, Helvetica, Arial, sans-serif";
const $67af8818136e32f9$export$8672fecfd7ee8e43 = "CC";
const $67af8818136e32f9$export$e7479e88c02d4fb8 = "99";
const $67af8818136e32f9$export$db70dedbbe0c82d3 = "66";
const $67af8818136e32f9$export$daea0760a35e21f = "33";
const $67af8818136e32f9$export$fd727ce0acbfa332 = {
    fontFamily: $67af8818136e32f9$export$f6740272b5923b9c,
    white: "white",
    black: "black",
    colorNeutralBackground1Hover: "#E1E3E6",
    gray: {
        gray92: "#E6E8EA",
        gray88: "#DADDDF",
        background: "#F0F1F3",
        light1: "#F9F9FA",
        light2: "#E1E3E6",
        light3: "#E7E8EB",
        dark1: "#818A98",
        dark2: "#333333",
        /* not an official color, need to find out what dark2 should be */ dark3: "#1A1B1E"
    },
    purple: {
        brand: {
            dark3: "#170046",
            dark2: "#2F037C",
            dark1: "#4A24AE",
            accent: "#5F41C9",
            light1: "#7D64EF",
            light2: "#B8B4FF",
            light3: "#E5E5FC"
        },
        supplementary: {
            hero: "#6D31FB",
            standard1: "#5F41C9",
            standard2: "#4A24AE",
            visited: "#766AB7"
        }
    },
    blue: {
        blue20: "#083368",
        blue95: "#E3F2FD"
    },
    green: {
        dark: "#1A3D00",
        light: "#EAF5DB"
    },
    yellow: {
        light: "#FEEFE1",
        dark: "#572300"
    },
    borderRadius: {
        small: ".25rem",
        medium: ".5rem",
        large: ".5rem",
        circular: "50%"
    },
    spacing: {
        large: "1.5rem",
        medium: "1rem",
        small: ".5rem",
        xsmall: ".25rem"
    },
    shadows: {
        none: "0 0 0 0px"
    }
};
const $67af8818136e32f9$var$buttonBase = {
    fontFamily: $67af8818136e32f9$export$f6740272b5923b9c,
    lineHeight: "18px",
    fontSize: "14px",
    paddingLeft: "1rem",
    paddingRight: "1rem",
    paddingTop: "0.375rem",
    paddingBottom: "0.5rem",
    ...(0, $bWnsf$shorthands).borderRadius("0.25rem")
};
const $67af8818136e32f9$export$939828d7e4979ffe = (0, $bWnsf$makeStyles)({
    Container: {
        marginLeft: "auto",
        marginRight: "auto",
        paddingLeft: "0",
        paddingRight: "0",
        width: "90%",
        "@media (min-width: 1535px)": {
            maxWidth: "1600px"
        },
        "@media (max-width: 860px)": {
            width: "95%"
        }
    },
    // h1's
    XdsHeading1: {
        fontFamily: $67af8818136e32f9$export$f6740272b5923b9c,
        lineHeight: "48px",
        fontWeight: "semi-bold",
        size: "48px",
        verticalAlign: "middle",
        /* on smaller screens, the type ramp shrinks */ "@media(max-width: 1365px)": {
            size: "26px",
            lineHeight: "32px",
            fontWeight: "semi-bold"
        }
    },
    // h2's
    XdsHeading2: {
        fontFamily: $67af8818136e32f9$export$f6740272b5923b9c,
        lineHeight: "40px",
        fontWeight: "semi-bold",
        size: "32px",
        verticalAlign: "middle",
        marginTop: 0,
        marginBottom: 0,
        /* on smaller screens, the type ramp shrinks */ "@media(max-width: 1365px)": {
            size: "26px",
            lineHeight: "32px",
            fontWeight: "semi-bold"
        }
    },
    // h3's
    XdsHeading3: {
        fontFamily: $67af8818136e32f9$export$f6740272b5923b9c,
        lineHeight: "32px",
        fontWeight: "semi-bold",
        size: "26px",
        verticalAlign: "middle",
        /* on smaller screens, the type ramp shrinks */ "@media(max-width: 1365px)": {
            size: "20px",
            lineHeight: "24px",
            fontWeight: "semi-bold"
        }
    },
    // Title elements in cards, etc- 1 corresponds to a card with a title at the h1 level
    XdsTitle1: {
        fontFamily: $67af8818136e32f9$export$f6740272b5923b9c,
        lineHeight: "32px",
        fontWeight: "bold",
        size: "26px",
        verticalAlign: "middle",
        /* on smaller screens, the type ramp shrinks */ "@media(max-width: 1365px)": {
            size: "20px",
            lineHeight: "24px",
            fontWeight: "bold"
        }
    },
    // Title elements in cards, etc- 2 corresponds to a card with a title at the h2 level
    XdsTitle2: {
        fontFamily: $67af8818136e32f9$export$f6740272b5923b9c,
        lineHeight: "26px !important",
        fontWeight: "bold !important",
        size: "32px !important",
        verticalAlign: "middle !important",
        /* on smaller screens, the type ramp shrinks */ "@media(max-width: 1365px)": {
            size: "20px !important",
            lineHeight: "24px !important",
            fontWeight: "bold !important"
        }
    },
    // Title elements in cards, etc- 3 corresponds to a card with a title at the h3 level
    XdsTitle3: {
        fontFamily: $67af8818136e32f9$export$f6740272b5923b9c,
        lineHeight: "20px !important",
        fontWeight: "bold !important",
        size: "16px !important",
        verticalAlign: "middle !important",
        /* on smaller screens, the type ramp shrinks */ "@media(max-width: 1365px)": {
            size: "14px !important !important",
            lineHeight: "18px !important",
            fontWeight: "bold !important"
        }
    },
    XdsTitle4: {
        fontFamily: $67af8818136e32f9$export$f6740272b5923b9c,
        lineHeight: "18px !important",
        fontWeight: "bold !important",
        size: "14px !important",
        verticalAlign: "middle !important"
    },
    XdsCaption: {
        fontFamily: $67af8818136e32f9$export$f6740272b5923b9c,
        color: $67af8818136e32f9$export$fd727ce0acbfa332.gray.dark3,
        lineHeight: "20px",
        fontWeight: "normal",
        size: "14px",
        verticalAlign: "middle",
        /* on smaller screens, the type ramp shrinks */ "@media(max-width: 1365px)": {
            size: "14px",
            lineHeight: "20px",
            fontWeight: "normal"
        }
    },
    XdsSubtitle1: {
        fontFamily: $67af8818136e32f9$export$f6740272b5923b9c,
        lineHeight: "24px !important",
        size: "20px !important",
        verticalAlign: "middle !important",
        fontWeight: "normal",
        /* on smaller screens, the type ramp shrinks */ "@media(max-width: 1365px)": {
            size: "16px !important",
            lineHeight: "20px !important"
        }
    },
    XdsSubtitle2: {
        fontFamily: $67af8818136e32f9$export$f6740272b5923b9c,
        lineHeight: "20px !important",
        size: "16px !important",
        verticalAlign: "middle !important",
        fontWeight: "normal",
        "@media(max-width: 1365px)": {
            size: "14px !important",
            lineHeight: "18px !important"
        }
    },
    XdsSubtitle3: {
        fontFamily: $67af8818136e32f9$export$f6740272b5923b9c,
        lineHeight: "18px !important",
        size: "14px !important",
        verticalAlign: "middle !important",
        fontWeight: "normal"
    },
    XdsBody: {
        fontFamily: $67af8818136e32f9$export$f6740272b5923b9c,
        lineHeight: "24px !important",
        size: "16px !important",
        verticalAlign: "middle !important",
        fontWeight: "normal"
    },
    XdsCta: {
        fontFamily: $67af8818136e32f9$export$f6740272b5923b9c,
        lineHeight: "18px !important",
        size: "14px !important",
        fontWeight: 600
    },
    VerticalLineClamp2: {
        display: "-webkit-box",
        WebkitLineClamp: "2",
        WebkitBoxOrient: "vertical",
        overflowY: "hidden"
    },
    /* Intended to be assigned to buttons which contain an Icon and Text. Icon should be a back Chevron:
        <Button className={xdsStyles.BackButton} appearance={"transparent"} onClick={() => navigate(routes.HOME())}>
            <ChevronLeft12Regular />
            {i18n.t(Strings.issues)}
        </Button>
    */ BackButton: {
        maxWidth: "fit-content",
        display: "flex",
        flexDirection: "row",
        justifyContent: "start",
        alignItems: "bottom",
        ...(0, $bWnsf$shorthands).gap(".25rem"),
        ...(0, $bWnsf$shorthands).padding(0),
        ...(0, $bWnsf$shorthands).margin(0),
        cursor: "pointer",
        fontFamily: $67af8818136e32f9$export$f6740272b5923b9c,
        lineHeight: "18px",
        fontWeight: "normal",
        size: "14px",
        verticalAlign: "middle",
        ...(0, $bWnsf$shorthands).textDecoration("none")
    }
});


const $421cb62d29dc64cf$export$28e6b9b82ee883c = (0, $bWnsf$makeStyles)({
    root: {
        ...(0, $bWnsf$shorthands).padding((0, $bWnsf$tokens).spacingHorizontalL)
    },
    headerIcons: {
        display: "flex",
        justifyContent: "flex-end"
    },
    header: {
        marginBottom: (0, $bWnsf$tokens).spacingVerticalM
    },
    accountHeader: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "start",
        marginTop: (0, $bWnsf$tokens).spacingVerticalXL
    },
    avatar: {
        width: "54px",
        height: "54px"
    },
    accountUsername: {
    },
    accountContent: {
        display: "flex",
        flexDirection: "column",
        marginLeft: (0, $bWnsf$tokens).spacingHorizontalM
    },
    accountSettings: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center"
    },
    settingsButton: {
    },
    dividerRoot: {
        display: "flex",
        justifyContent: "center",
        width: "100%"
    },
    dividerWrapper: {
        display: "flex",
        minHeight: "16px"
    },
    divider: {
        width: "300px"
    },
    currentTenantTextWrapper: {
        display: "flex",
        marginTop: (0, $bWnsf$tokens).spacingVerticalS,
        marginBottom: (0, $bWnsf$tokens).spacingVerticalL
    },
    currentTenantText: {
    },
    infoLink: {
        display: "flex",
        alignItems: "center",
        minWidth: "16px",
        ...(0, $bWnsf$shorthands).padding(0),
        ...(0, $bWnsf$shorthands).border("none"),
        marginLeft: (0, $bWnsf$tokens).spacingHorizontalXS
    },
    currentTenantCard: {
        ...(0, $bWnsf$shorthands).border("1px", "solid"),
        ...(0, $bWnsf$shorthands).borderColor((0, $67af8818136e32f9$export$fd727ce0acbfa332).purple.brand.accent),
        "&:hover": {
            backgroundColor: "#ffffff"
        },
        "&:active": {
            backgroundColor: "#ffffff"
        },
        marginTop: (0, $bWnsf$tokens).spacingVerticalL,
        marginBottom: (0, $bWnsf$tokens).spacingVerticalL,
        cursor: "default"
    },
    switchableTenantCard: {
        ...(0, $bWnsf$shorthands).border("1px", "solid"),
        ...(0, $bWnsf$shorthands).borderColor("#E7E8EB"),
        marginTop: (0, $bWnsf$tokens).spacingVerticalL,
        marginBottom: (0, $bWnsf$tokens).spacingVerticalL
    }
});





var $902673c71e2ae30d$exports = {};

$parcel$export($902673c71e2ae30d$exports, "useGameDevAuthTenants", () => $902673c71e2ae30d$export$2c12ae7bb09f9b21);


function $902673c71e2ae30d$export$2c12ae7bb09f9b21() {
    const [state, dispatch] = (0, $21975582a087385b$export$8a1842fae71241ae)();
    const setter = (0, $bWnsf$useCallback)((tenants)=>dispatch({
            type: "set_tenants",
            payload: tenants
        }), [
        dispatch
    ]);
    return (0, $bWnsf$useMemo)(()=>[
            state.tenants,
            setter
        ], [
        setter,
        state.tenants
    ]);
}


var $bc133421151b4e15$exports = {};

$parcel$export($bc133421151b4e15$exports, "useGameDevAuthTenantId", () => $bc133421151b4e15$export$d366d1f365c112f5);


function $bc133421151b4e15$export$d366d1f365c112f5() {
    const [state, dispatch] = (0, $21975582a087385b$export$8a1842fae71241ae)();
    const setter = (0, $bWnsf$useCallback)((tenantId)=>dispatch({
            type: "set_tenant_id",
            payload: tenantId
        }), [
        dispatch
    ]);
    return (0, $bWnsf$useMemo)(()=>[
            state.tenantId,
            setter
        ], [
        setter,
        state.tenantId
    ]);
}




var $907e740aeadb542a$exports = {};

$parcel$export($907e740aeadb542a$exports, "useGameDevAuthSellerId", () => $907e740aeadb542a$export$c71a58f23f89881e);


function $907e740aeadb542a$export$c71a58f23f89881e() {
    const [state, dispatch] = (0, $21975582a087385b$export$8a1842fae71241ae)();
    const setter = (0, $bWnsf$useCallback)((sellerId)=>dispatch({
            type: "set_seller_id",
            payload: sellerId
        }), [
        dispatch
    ]);
    return (0, $bWnsf$useMemo)(()=>[
            state.sellerId,
            setter
        ], [
        setter,
        state.sellerId
    ]);
}











const $108b8e206be54104$export$4e1325d0d7b9556e = ({ displayName: displayName, defaultDomain: defaultDomain, tenantId: tenantId, onDefaultTenantChange: onDefaultTenantChange, onTenantChange: onTenantChange })=>{
    const classes = (0, $421cb62d29dc64cf$export$28e6b9b82ee883c)();
    const [strings] = (0, $a123e35769e182e0$export$938b22d9142905e3)();
    const [defaultTenantId, setDefaultTenantId] = (0, $edbc0b837dea9b55$export$5d2f8d2d1d136498)();
    const [selectedTenantId] = (0, $bc133421151b4e15$export$d366d1f365c112f5)();
    const HomeIcon = (0, $bWnsf$bundleIcon)((0, $bWnsf$Home24Filled), (0, $bWnsf$Home24Regular));
    const OpenIcon = (0, $bWnsf$bundleIcon)((0, $bWnsf$Open24Filled), (0, $bWnsf$Open24Regular));
    const handleSetDefaultTenant = (0, $bWnsf$useCallback)((tenantId)=>{
        if (onDefaultTenantChange) onDefaultTenantChange(tenantId);
        else setDefaultTenantId(tenantId);
    }, []);
    return /*#__PURE__*/ (0, $bWnsf$jsx)((0, $bWnsf$Card), {
        className: `${tenantId === selectedTenantId ? classes.currentTenantCard : classes.switchableTenantCard}`,
        onClick: ()=>{
            onTenantChange();
        },
        children: /*#__PURE__*/ (0, $bWnsf$jsx)((0, $bWnsf$CardHeader), {
            action: /*#__PURE__*/ (0, $bWnsf$jsxs)((0, $bWnsf$Menu), {
                hasIcons: true,
                children: [
                    /*#__PURE__*/ (0, $bWnsf$jsx)((0, $bWnsf$MenuTrigger), {
                        disableButtonEnhancement: true,
                        children: /*#__PURE__*/ (0, $bWnsf$jsx)((0, $bWnsf$Button), {
                            appearance: "transparent",
                            icon: /*#__PURE__*/ (0, $bWnsf$jsx)((0, $bWnsf$MoreHorizontal24Filled), {}),
                            title: strings.OptionsButtonLabel,
                            "aria-label": strings.OptionsButtonLabel,
                            onClick: (e)=>{
                                e.stopPropagation();
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $bWnsf$jsx)((0, $bWnsf$MenuPopover), {
                        children: /*#__PURE__*/ (0, $bWnsf$jsxs)((0, $bWnsf$MenuList), {
                            children: [
                                /*#__PURE__*/ (0, $bWnsf$jsx)((0, $bWnsf$MenuItem), {
                                    onClick: (e)=>{
                                        e.stopPropagation();
                                        handleSetDefaultTenant(tenantId);
                                    },
                                    icon: tenantId === defaultTenantId ? /*#__PURE__*/ (0, $bWnsf$jsx)((0, $bWnsf$Home24Filled), {}) : /*#__PURE__*/ (0, $bWnsf$jsx)(HomeIcon, {}),
                                    children: /*#__PURE__*/ (0, $bWnsf$jsx)((0, $bWnsf$Body1), {
                                        children: tenantId === defaultTenantId ? strings.ThisIsDefault : strings.SetAsDefault
                                    })
                                }),
                                /*#__PURE__*/ (0, $bWnsf$jsx)((0, $bWnsf$MenuItem), {
                                    icon: /*#__PURE__*/ (0, $bWnsf$jsx)(OpenIcon, {}),
                                    children: /*#__PURE__*/ (0, $bWnsf$jsx)((0, $bWnsf$Link), {
                                        target: "_blank",
                                        href: "https://portal.azure.com/#blade/Microsoft_AAD_IAM/ActiveDirectoryMenuBlade/Overview",
                                        appearance: "subtle",
                                        onClick: (e)=>{
                                            e.stopPropagation();
                                        },
                                        children: /*#__PURE__*/ (0, $bWnsf$jsx)((0, $bWnsf$Body1), {
                                            children: strings.ManageInAzure
                                        })
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            header: /*#__PURE__*/ (0, $bWnsf$jsx)((0, $bWnsf$Body1Strong), {
                children: displayName
            }),
            description: /*#__PURE__*/ (0, $bWnsf$jsx)((0, $bWnsf$Caption2), {
                children: defaultDomain
            })
        })
    });
};


function $b5d306f4b35768c6$export$105b0d753a45dc96({ width: width = 350, closeOnSwitchTenant: closeOnSwitchTenant = false, closeOnSwitchSeller: closeOnSwitchSeller = false, onClose: onClose, onPin: onPin, onUnpin: onUnpin, onTenantChange: onTenantChange, onSellerChange: onSellerChange, onDefaultTenantChange: onDefaultTenantChange, onDefaultSellerChange: onDefaultSellerChange }) {
    const classes = (0, $421cb62d29dc64cf$export$28e6b9b82ee883c)();
    const [account] = (0, $73b8a0d69df8c02d$export$8b78e3b2832dcdba)();
    const [strings] = (0, $a123e35769e182e0$export$938b22d9142905e3)();
    const [dirPickerState, setDirPickerState] = (0, $1b99332a36d0bc3c$export$8029427447337e06)();
    const [, setDefaultTenantId] = (0, $edbc0b837dea9b55$export$5d2f8d2d1d136498)();
    const [, setDefaultSellerId] = (0, $ff91fd666453c646$export$31dba69c0f16c609)();
    const [selectedTenantId, setSelectedTenantId] = (0, $bc133421151b4e15$export$d366d1f365c112f5)();
    const [, setSelectedSellerId] = (0, $907e740aeadb542a$export$c71a58f23f89881e)();
    const [tenants] = (0, $902673c71e2ae30d$export$2c12ae7bb09f9b21)();
    const selectedTenant = (0, $bWnsf$useMemo)(()=>tenants?.find((tenant)=>tenant.tenantId === selectedTenantId), [
        selectedTenantId,
        tenants
    ]);
    const unSelectedTenants = (0, $bWnsf$useMemo)(()=>tenants?.filter((tenant)=>tenant.tenantId !== selectedTenantId) || [], [
        selectedTenantId,
        tenants
    ]);
    const handleClose = (0, $bWnsf$useCallback)(()=>{
        if (dirPickerState === "pinned") return;
        if (onClose) onClose();
        else setDirPickerState("closed");
    }, [
        dirPickerState,
        setDirPickerState,
        onClose
    ]);
    const handlePin = (0, $bWnsf$useCallback)(()=>{
        if (onPin) onPin();
        else setDirPickerState("pinned");
    }, [
        setDirPickerState,
        onClose
    ]);
    const handleUnpin = (0, $bWnsf$useCallback)(()=>{
        if (onUnpin) onUnpin();
        else setDirPickerState("opened");
    }, [
        setDirPickerState
    ]);
    const handleTenantChange = (0, $bWnsf$useCallback)((tenantId)=>{
        if (onTenantChange) onTenantChange(tenantId);
        else {
            setSelectedTenantId(tenantId);
            if (closeOnSwitchTenant) handleClose();
        }
    }, [
        setSelectedTenantId,
        closeOnSwitchTenant,
        handleClose
    ]);
    const handleSellerChange = (0, $bWnsf$useCallback)((sellerId)=>{
        if (onSellerChange) onSellerChange(sellerId);
        else {
            setSelectedSellerId(sellerId);
            if (closeOnSwitchSeller) handleClose();
        }
    }, [
        setSelectedSellerId,
        closeOnSwitchSeller,
        handleClose
    ]);
    const handleSetDefaultTenant = (0, $bWnsf$useCallback)((tenantId)=>{
        if (onDefaultTenantChange) onDefaultTenantChange(tenantId);
        else setDefaultTenantId(tenantId);
    }, []);
    const handleSetDefaultSeller = (0, $bWnsf$useCallback)((sellerId)=>{
        if (onDefaultSellerChange) onDefaultSellerChange(sellerId);
        else setDefaultSellerId(sellerId);
    }, []);
    return /*#__PURE__*/ (0, $bWnsf$jsxs)((0, $bWnsf$DrawerOverlay), {
        modalType: "non-modal",
        position: "end",
        open: dirPickerState === "opened" || dirPickerState === "pinned",
        onOpenChange: (_, { open: open })=>{
            if (!open) handleClose();
        },
        children: [
            /*#__PURE__*/ (0, $bWnsf$jsxs)((0, $bWnsf$DrawerHeader), {
                children: [
                    /*#__PURE__*/ (0, $bWnsf$jsx)((0, $bWnsf$DrawerHeaderTitle), {
                        action: /*#__PURE__*/ (0, $bWnsf$jsx)((0, $bWnsf$Button), {
                            onClick: handleClose,
                            appearance: "transparent",
                            icon: /*#__PURE__*/ (0, $bWnsf$jsx)((0, $bWnsf$Dismiss24Regular), {}),
                            title: strings.CloseButtonLabel,
                            "aria-label": strings.CloseButtonLabel
                        }),
                        children: strings.SwitchDirectory
                    }),
                    /*#__PURE__*/ (0, $bWnsf$jsxs)("div", {
                        className: classes.accountHeader,
                        children: [
                            /*#__PURE__*/ (0, $bWnsf$jsx)((0, $bWnsf$Avatar), {
                                name: account.name,
                                image: {
                                    src: account.picture
                                },
                                size: 48,
                                className: classes.avatar
                            }),
                            /*#__PURE__*/ (0, $bWnsf$jsxs)("div", {
                                className: classes.accountContent,
                                children: [
                                    /*#__PURE__*/ (0, $bWnsf$jsx)("div", {
                                        className: classes.accountSettings,
                                        children: /*#__PURE__*/ (0, $bWnsf$jsx)((0, $bWnsf$Subtitle2), {
                                            children: account.name
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $bWnsf$jsx)((0, $bWnsf$Body1), {
                                        className: classes.accountUsername,
                                        children: account.username
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bWnsf$jsx)("div", {
                className: classes.dividerRoot,
                children: /*#__PURE__*/ (0, $bWnsf$jsx)("div", {
                    className: classes.dividerWrapper,
                    children: /*#__PURE__*/ (0, $bWnsf$jsx)((0, $bWnsf$Divider), {
                        inset: true,
                        className: classes.divider
                    })
                })
            }),
            /*#__PURE__*/ (0, $bWnsf$jsxs)((0, $bWnsf$DrawerBody), {
                children: [
                    selectedTenant && /*#__PURE__*/ (0, $bWnsf$jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $bWnsf$jsxs)("div", {
                                className: classes.currentTenantTextWrapper,
                                children: [
                                    /*#__PURE__*/ (0, $bWnsf$jsx)((0, $bWnsf$Body1), {
                                        className: classes.currentTenantText,
                                        children: strings.CurrentTenantAccount
                                    }),
                                    /*#__PURE__*/ (0, $bWnsf$jsx)((0, $bWnsf$Link), {
                                        appearance: "subtle",
                                        target: "_blank",
                                        href: "https://learn.microsoft.com/en-us/azure/active-directory/fundamentals/whatis",
                                        className: classes.infoLink,
                                        children: /*#__PURE__*/ (0, $bWnsf$jsx)((0, $bWnsf$Tooltip), {
                                            relationship: "label",
                                            content: strings.LinkText,
                                            children: /*#__PURE__*/ (0, $bWnsf$jsx)((0, $bWnsf$Info16Regular), {})
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $bWnsf$jsx)((0, $108b8e206be54104$export$4e1325d0d7b9556e), {
                                displayName: selectedTenant.displayName,
                                defaultDomain: selectedTenant.defaultDomain,
                                tenantId: selectedTenant.tenantId,
                                onDefaultTenantChange: handleSetDefaultTenant,
                                onTenantChange: ()=>{}
                            })
                        ]
                    }),
                    unSelectedTenants?.length > 0 && /*#__PURE__*/ (0, $bWnsf$jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $bWnsf$jsxs)((0, $bWnsf$Body1), {
                                children: [
                                    strings.SwitchTo,
                                    ":"
                                ]
                            }),
                            /*#__PURE__*/ (0, $bWnsf$jsx)("div", {
                                children: unSelectedTenants?.map((tenant)=>/*#__PURE__*/ (0, $bWnsf$jsx)((0, $108b8e206be54104$export$4e1325d0d7b9556e), {
                                        displayName: tenant.displayName,
                                        defaultDomain: tenant.defaultDomain,
                                        tenantId: tenant.tenantId,
                                        onDefaultTenantChange: handleSetDefaultTenant,
                                        onTenantChange: ()=>handleTenantChange(tenant.tenantId)
                                    }))
                            })
                        ]
                    })
                ]
            })
        ]
    });
}











const $e70d73ed7ea944ce$var$scopes = [
    "https://management.azure.com/user_impersonation"
];
const $e70d73ed7ea944ce$var$tenantsServiceEndpoint = "https://management.azure.com/tenants?api-version=2020-01-01";
function $e70d73ed7ea944ce$export$c26fb67445e44d20() {
    const { instance: msal } = (0, $bWnsf$useMsal)();
    const [account] = (0, $73b8a0d69df8c02d$export$8b78e3b2832dcdba)();
    const [, setTenants] = (0, $902673c71e2ae30d$export$2c12ae7bb09f9b21)();
    (0, $bWnsf$useEffect)(()=>{
        if (!account) return;
        setTenants(null);
        msal.acquireTokenSilent({
            scopes: $e70d73ed7ea944ce$var$scopes
        }).then((response)=>{
            (0, $bWnsf$axios).get($e70d73ed7ea944ce$var$tenantsServiceEndpoint, {
                headers: {
                    Authorization: `Bearer ${response.accessToken}`
                }
            }).then((response)=>{
                setTenants(response.data?.value || []);
            }).catch((error)=>{
                console.error(error);
            });
        }).catch((error)=>{
            console.error(error);
            msal.acquireTokenRedirect({
                scopes: $e70d73ed7ea944ce$var$scopes
            });
        });
    }, [
        account
    ]);
}


var $ff91fd666453c646$exports = {};

$parcel$export($ff91fd666453c646$exports, "useGameDevAuthDefaultSellerId", () => $ff91fd666453c646$export$31dba69c0f16c609);


function $ff91fd666453c646$export$31dba69c0f16c609() {
    const [state, dispatch] = (0, $21975582a087385b$export$8a1842fae71241ae)();
    const setter = (0, $bWnsf$useCallback)((defaultSellerId)=>dispatch({
            type: "set_default_seller_id",
            payload: defaultSellerId
        }), [
        dispatch
    ]);
    return (0, $bWnsf$useMemo)(()=>[
            state.defaultSellerId,
            setter
        ], [
        setter,
        state.defaultSellerId
    ]);
}



function $74675ca70fa08556$export$deca11256f311257({ loginBaseRequest: loginBaseRequest = {
    scopes: []
}, logoutBaseRequest: logoutBaseRequest = {}, onSignIn: onSignIn, onSignOut: onSignOut, onSwitchTo: onSwitchTo, onTenantChange: onTenantChange, onSellerChange: onSellerChange, autologin: autologin = true }) {
    const { instance: msal, accounts: accounts } = (0, $bWnsf$useMsal)();
    const msalAccount = accounts[0];
    const { instance: instance } = (0, $f69ccf510b0a32a4$export$dd40e6363faf0354)();
    const [account, setAccount] = (0, $73b8a0d69df8c02d$export$8b78e3b2832dcdba)();
    const [selectedTenantId, setSelectedTenantId] = (0, $bc133421151b4e15$export$d366d1f365c112f5)();
    const [, setSelectedSellerId] = (0, $907e740aeadb542a$export$c71a58f23f89881e)();
    const [, setDefaultSellerId] = (0, $ff91fd666453c646$export$31dba69c0f16c609)();
    // if no tenant defaults to msal configured authority
    const authority = (0, $bWnsf$useMemo)(()=>selectedTenantId ? instance + "/" + selectedTenantId : undefined, [
        selectedTenantId,
        instance
    ]);
    const signIn = (0, $bWnsf$useCallback)((args)=>{
        msal.loginRedirect({
            ...loginBaseRequest,
            authority: authority,
            loginHint: args?.nextAccount?.memberName
        }).catch(console.error);
    }, [
        msal,
        authority
    ]);
    const switchTo = (0, $bWnsf$useCallback)((args)=>{
        msal.loginRedirect({
            ...loginBaseRequest,
            authority: authority,
            loginHint: args?.nextAccount?.memberName,
            prompt: "select_account"
        }).catch(console.error);
    }, [
        msal,
        authority
    ]);
    const signOut = (0, $bWnsf$useCallback)((args)=>{
        msal.logoutRedirect({
            ...logoutBaseRequest,
            logoutHint: args?.currentAccount?.memberName
        }).catch(console.error);
    }, [
        msal
    ]);
    const handleTenantChange = (0, $bWnsf$useCallback)((newTenant)=>{
        setSelectedTenantId(newTenant);
        msal.loginRedirect({
            ...loginBaseRequest,
            authority: instance + "/" + newTenant,
            loginHint: account.username
        }).catch(console.error);
    }, [
        setSelectedTenantId,
        account,
        instance,
        loginBaseRequest,
        msal
    ]);
    const handleSellerChange = (0, $bWnsf$useCallback)((sellerId)=>{
        setDefaultSellerId(sellerId);
        setSelectedSellerId(sellerId);
        msal.loginRedirect({
            ...loginBaseRequest,
            authority: instance + "/" + selectedTenantId,
            loginHint: account.username
        }).catch(console.error);
    }, [
        account,
        instance,
        loginBaseRequest,
        msal,
        selectedTenantId
    ]);
    (0, $e70d73ed7ea944ce$export$c26fb67445e44d20)();
    (0, $bWnsf$useEffect)(()=>{
        if (!autologin) return;
        // If there is no account for session
        if (!msalAccount) signIn({});
        else if (msalAccount !== account) {
            // When the login completes there will be an account
            msal.setActiveAccount(msalAccount);
            setAccount(msalAccount);
        }
    }, [
        autologin,
        msalAccount?.tenantId,
        account
    ]);
    if (!account) return /*#__PURE__*/ (0, $bWnsf$jsx)((0, $c0016381562d3c19$export$36d4625ab12df346), {
        onSignIn: onSignIn || signIn,
        onSwitchTo: onSwitchTo || switchTo,
        onSignOut: onSignOut || signOut
    });
    return /*#__PURE__*/ (0, $bWnsf$jsxs)((0, $bWnsf$Fragment), {
        children: [
            /*#__PURE__*/ (0, $bWnsf$jsx)((0, $c0016381562d3c19$export$36d4625ab12df346), {
                onSignIn: onSignIn || signIn,
                onSwitchTo: onSwitchTo || switchTo,
                onSignOut: onSignOut || signOut
            }),
            /*#__PURE__*/ (0, $bWnsf$jsx)((0, $b5d306f4b35768c6$export$105b0d753a45dc96), {
                onTenantChange: onTenantChange || handleTenantChange,
                onSellerChange: onSellerChange || handleSellerChange,
                closeOnSwitchTenant: true,
                closeOnSwitchSeller: true
            })
        ]
    });
}






var $edbc0b837dea9b55$exports = {};

$parcel$export($edbc0b837dea9b55$exports, "useGameDevAuthDefaultTenantId", () => $edbc0b837dea9b55$export$5d2f8d2d1d136498);


function $edbc0b837dea9b55$export$5d2f8d2d1d136498() {
    const [state, dispatch] = (0, $21975582a087385b$export$8a1842fae71241ae)();
    const setter = (0, $bWnsf$useCallback)((defaultTenantId)=>dispatch({
            type: "set_default_tenant_id",
            payload: defaultTenantId
        }), [
        dispatch
    ]);
    return (0, $bWnsf$useMemo)(()=>[
            state.defaultTenantId,
            setter
        ], [
        setter,
        state.defaultTenantId
    ]);
}






var $4f96a7f68b1db996$exports = {};

$parcel$export($4f96a7f68b1db996$exports, "useGameDevAuthSellers", () => $4f96a7f68b1db996$export$dcd044a7399883cc);


function $4f96a7f68b1db996$export$dcd044a7399883cc() {
    const [state, dispatch] = (0, $21975582a087385b$export$8a1842fae71241ae)();
    const setter = (0, $bWnsf$useCallback)((sellers)=>dispatch({
            type: "set_sellers",
            payload: sellers
        }), [
        dispatch
    ]);
    return (0, $bWnsf$useMemo)(()=>[
            state.sellers,
            setter
        ], [
        setter,
        state.sellers
    ]);
}






var $f55e26e9b42eb484$exports = {};

$parcel$export($f55e26e9b42eb484$exports, "useGameDevAuthClaims", () => $f55e26e9b42eb484$export$f784fa6c9bd06efd);


function $f55e26e9b42eb484$export$f784fa6c9bd06efd() {
    const [state, dispatch] = (0, $21975582a087385b$export$8a1842fae71241ae)();
    const setter = (0, $bWnsf$useCallback)((claims)=>dispatch({
            type: "set_claims",
            payload: claims
        }), [
        dispatch
    ]);
    return (0, $bWnsf$useMemo)(()=>[
            state.claims,
            setter
        ], [
        setter,
        state.claims
    ]);
}




export {$90b60284c280181b$export$97a7af6687d86f01 as GameDevAuthProvider, $74675ca70fa08556$export$deca11256f311257 as GameDevAuth, $c0016381562d3c19$export$36d4625ab12df346 as GameDevAuthMeControl, $b5d306f4b35768c6$export$105b0d753a45dc96 as GameDevAuthDirectoryPicker, $21975582a087385b$export$8a1842fae71241ae as useGameDevAuthContext, $73b8a0d69df8c02d$export$8b78e3b2832dcdba as useGameDevAuthAccount, $edbc0b837dea9b55$export$5d2f8d2d1d136498 as useGameDevAuthDefaultTenantId, $ff91fd666453c646$export$31dba69c0f16c609 as useGameDevAuthDefaultSellerId, $bc133421151b4e15$export$d366d1f365c112f5 as useGameDevAuthTenantId, $907e740aeadb542a$export$c71a58f23f89881e as useGameDevAuthSellerId, $902673c71e2ae30d$export$2c12ae7bb09f9b21 as useGameDevAuthTenants, $4f96a7f68b1db996$export$dcd044a7399883cc as useGameDevAuthSellers, $7a51392e39a432a5$export$2694ca027c248780 as useGameDevAuthLang, $f69ccf510b0a32a4$export$dd40e6363faf0354 as useGameDevAuthMeta, $3020c252d16c3fff$export$107c920f942946ca as useGameDevAuthTheme, $1b99332a36d0bc3c$export$8029427447337e06 as useGameDevAuthDirPicker, $f55e26e9b42eb484$export$f784fa6c9bd06efd as useGameDevAuthClaims};
//# sourceMappingURL=index.esm.js.map
